// extracted by mini-css-extract-plugin
module.exports = {"player-mark-switch":"styles_player-mark-switch__1o6dN","mark":"styles_mark__3h723","selected":"styles_selected__2Z9Ns"};